import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {List} from "immutable";
import connect from "react-redux/es/connect/connect";
import {Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem} from "@blueprintjs/core";
import numeral from "numeral";

// Components
import VirtualizedTable from "../../../components/common/virtualized-table";

// Actions
import {cleanIssues, getIssues} from "../../../actions/issues";

// Numeral configuration
import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class SalesOrderIssues extends Component {
    componentDidMount() {
        this.props.getIssues({
            filters: { orders: this.props.salesOrder.get('_id') },
            projection: 'issue_code document_date delivery_date customer order statistics.subtotal statistics.vat statistics.total',
            populateRefs: [{
                field: 'customer',
                projection: 'basic_info.name'
            }],
            calculateStatistics: 'issues',
            deleteVirtuals: true
        });
    }

    render() {
        // Stats Zone
        let totalIssues = 0;
        this.props.issues.forEach(issue => totalIssues = totalIssues + issue.getIn(['statistics', 'total']));

        // Issues Table
        let tableData = this.props.issues;
        let tableSettings = {
            showFooter: true,
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            issue_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'issue_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/ventas/albaranes/' + value[0] }>{ value[1] }</Link>
                }
            },
            document_date: {
                title: "Fecha",
                columnType: 'date',
                dataField: 'document_date',
                width: 100,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            delivery_date: {
                title: "Fecha de entrega",
                columnType: 'date',
                dataField: 'delivery_date',
                width: 150,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            customer: {
                title: "Cliente",
                columnType: 'text',
                dataField: 'customer',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
            },
            order: {
                title: 'Pedido',
                columnType: 'function',
                dataField: ['order._id', 'order.order_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/ventas/pedidos/' + value[0] }>{ value[1] }</Link>
                }
            },
            subtotal: {
                title: "Subtotal",
                columnType: 'number',
                dataField: 'statistics.subtotal',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            vat: {
                title: "IVA",
                columnType: 'number',
                dataField: 'statistics.vat',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            total: {
                title: "Total",
                columnType: 'number',
                dataField: 'statistics.total',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    let popoverContent = (
                        <Menu>
                            <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/ventas/albaranes/' + value)} />
                        </Menu>
                    );

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        return (
            <div className="panel-body">
                <div className="row stats-zone" style={{ marginBottom: 20 }} >
                    <div className="col-auto">
                        <span className="label ">{ this.props.issues.size || 0 }</span>
                        <span>Albaranes</span>
                    </div>
                    <div className="col-auto">
                        <span className="label ">{ numeral(totalIssues).format() }</span>
                        <span>Importe total albaranes</span>
                    </div>
                    { this.props.canNewIssue
                        ? <div className="col-auto ml-auto">
                            <button
                                className="btn btn-primary"
                                onClick={ () => this.props.history.push('/ventas/albaranes/nuevo', { salesOrder: this.props.salesOrder }) }
                            >
                                <Icon icon="insert"/>Albarán
                            </button>
                        </div>
                        : null
                    }
                </div>
                <div className="row">
                    <div className="col">
                        <div className="ibox">
                            <div className="ibox-content">
                                <VirtualizedTable
                                    tableSettings={tableSettings}
                                    tableColumns={tableColumns}
                                    tableData={tableData}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {

    // Reducers
    const issuesReducer = state.issues;

    // Issues
    let issues = issuesReducer.get('payload') || List([]);

    if (!(issues instanceof List)) {
        issues = List([])
    }

    return {
        issues
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getIssues: (query) => dispatch(getIssues(query)),
        cleanIssues: () => dispatch(cleanIssues())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderIssues);



// WEBPACK FOOTER //
// ./src/containers/sales/orders/SalesOrderIssues.js